import { Link } from "react-router-dom";
import "./Button.css";

const ButtonPlane = ({
  children,
  onClick,
  disabled,
  size,
  span,
  type,
  link,
  className
}: {
  children: string;
  onClick?: (data?: any) => void;
  disabled?: boolean;
  size?: `sm` | `md` | `lg`;
  link?: string;
  type?: `button` | `submit`;
  span?: boolean;
  className?: string;
}) => {
  return link ? (
    <Link to={link || `#`} className={`btnPlane_link ${span ? `flex1` : ``}`}>
      <button
        type={type || "button"}
        onClick={(e) => {
          if (onClick) {
            onClick(e);
          }
        }}
        className={`btnPlane ${size || ``} ${span ? `flex1` : ``} ${
          className || ""
        }`}
      >
        {children}
      </button>
    </Link>
  ) : (
    <button
      type={type || "button"}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      className={`btnPlane ${size || ``} ${span ? `flex1` : ``} ${
        className || ""
      }`}
    >
      {children}
    </button>
  );
};

export default ButtonPlane;
